import { render } from "./PrivacyPolicy.vue?vue&type=template&id=3271c556"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"
script.render = render

export default script